import moment from 'moment';

export const formatDateStr = (ts, format = 'hh:mm:ss MM-DD-YYYY') => {
  return moment.unix(ts).format(format);
};

export const calDuration = (startTime, endTime) => {
  const start = moment.unix(startTime);
  const end = moment.unix(endTime);
  const diff = moment.duration(end.diff(start));
  return moment.utc(diff.asMilliseconds()).format('HH:mm:ss');
};

export const toHoursAndMinutes = (totalSeconds) => {
  if (totalSeconds > 0) {
    const totalMinutes = Math.floor(totalSeconds / 60);

    const seconds = totalSeconds % 60;
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return { h: hours, m: minutes, s: seconds };
  } else {
    return { h: 0, m: 0, s: 0 }
  }
}
export const getDiffTimeFromNow = (startTime) => {
  return new Date().getTime() - startTime;
};

export const getTotalRequiredSecondsPerDevice = (dateRanger) => {
  const now = moment();
  const todayStart = moment().startOf('day');

  if (!dateRanger || !dateRanger[0] || !dateRanger[1]) {
    const todaySeconds = Math.max(0, now.diff(todayStart, 'seconds'));
    return todaySeconds;
  }

  const start = moment(dateRanger[0]).startOf('day');
  const end = moment(dateRanger[1]).endOf('day');

  if (end.isSameOrAfter(todayStart)) {
    let pastSeconds = 0;
    if (start.isBefore(todayStart)) {
      const pastDays = todayStart.diff(start, 'days');
      pastSeconds = pastDays * 86400;
    }
    const todaySeconds = Math.max(0, now.diff(todayStart, 'seconds'));
    return pastSeconds + todaySeconds;
  } else {
    const diffDays = end.diff(start, 'days') + 1;
    const days = diffDays > 0 ? diffDays : 1;
    return days * 86400;
  }
};

